import { useState, useMemo } from "react";
import type { DropdownOption } from "ui";

export function useDeclineTypeFilter() {
  const [selectedType, setSelectedType] = useState<DropdownOption<string>>([
    "ALL_TYPES",
    "All types",
  ]);

  const typeOptions: DropdownOption<string>[] = useMemo(
    () => [
      ["ALL_TYPES", "All types"],
      ["SOFT_DECLINE", "Soft decline"],
      ["HARD_DECLINE", "Hard decline"],
    ],
    []
  );

  return {
    selectedType,
    setSelectedType,
    typeOptions,
  };
}
